export const MONTHS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août'];
export const MAX_DAYS = 31;
export const WEEKS_PER_YEAR = 52;

// Default page size of the paginated list pages
export const DEFAULT_ITEMS_PER_PAGE = 25;
